import { DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutAddMenuBranch extends Layout {
    labelB: Label;
    labelC: Label;
    layoutBranch: Layout;
    layoutLeaf: Layout;
    panelBranch: Panel;
    panelItem: Panel;
    sourceBranch: DataSource;
    sourceLeaf: DataSource;
}
